import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import generateValidator from './Validations/generateValidator';

import Section from './Section.js'
import CustomSpinner from './CustomSpinner';
import RenderField from './RenderField';
import CustomAlert from '../components/CustomAlert.js';
import StatesList from '../containers/StatesContainer.js';
import CustomAutosuggestMobileFriendly from './CustomAutosuggestMobileFriendly';


class CompanyAddressForm extends Component {

    constructor(props) {
        super(props);
        this.state = { cities: null };
    }

    render() {
        const { handleSubmit, submitting, error, state_id } = this.props;

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_company_address" description="Address info"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveCompanyAddress)} className="pvc-form" autoComplete="asd">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_business_name" autoComplete="off" component={RenderField} type="text" label="Empresa" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <StatesList name={'work_state_id'} />
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_locality" autoComplete="asd" component={CustomAutosuggestMobileFriendly} selectedState={state_id} type="text" label="Localidad" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_address_street" autoComplete="off" component={RenderField} type="text" label="Calle y Número" />
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_address_description" autoComplete="off" component={RenderField} type="text" label="N° dpto, N° piso, etc" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="work_zip_code" autoComplete="off" component={RenderField} type="number" label="Código Postal" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

CompanyAddressForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([
    {name: 'work_business_name', required: true},
    {name: 'work_state_id', required: true},
    {name: 'work_locality', required: true},
    {name: 'work_address_street', required: true},
]);

const selector = formValueSelector('CompanyAddressForm')

CompanyAddressForm = connect(
    state => {
        const state_id = selector(state, 'work_state_id')
        return {
            state_id
        }
    }
)(CompanyAddressForm)

CompanyAddressForm = TopScrolleable(CompanyAddressForm);

CompanyAddressForm = reduxForm({
    form: 'CompanyAddressForm', // a unique name for this form
    validate
})(CompanyAddressForm);

CompanyAddressForm = withAuthControl(CompanyAddressForm);

export default CompanyAddressForm;



/** WEBPACK FOOTER **
 ** ./src/components/CompanyAddressForm.js
 **/